import React from 'react'

const alertTemplate = ({ style, options, message, close }) => {
  const cssClass = (alertType) => {
    switch (alertType) {
     case "success": return "alert alert-success"
     case "error": return "alert alert-danger"
     default: return "alert"
    }
  }

  return (
    <div style={style}>
      <div onClick={close} className={cssClass(options.type)} role="alert">
        {message}
      </div>
    </div>
  )
}

export default alertTemplate;



// WEBPACK FOOTER //
// ./src/components/Shared/AlertTemplate.js